<script>
export default {
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
    }
  },
  mounted() {
    defineSlice({
      description: 'Big gold full bleed with a "Save Up To" section.',
      fields: {
        title: {
          type: 'text',
          label: 'Title',
          editorLabel: true,
        },
        subtitle: { type: 'text', label: 'Sub-title', enabled: false },
        introduction: { type: 'wysiwyg', label: 'Introduction' },
        savings: { type: 'text', label: 'Savings' },
        isDollars: { type: 'checkbox', label: 'Is Dollars?', instructions: '"This toggles between dollars and percent"', default: false },
        terms: { type: 'wysiwyg', label: 'Terms & Conditions' },
      },
      name: { label: 'Gold Promotion', group: 'Sanctuary', layouts: ['Sanctuary'] },
      preview: 'SlicesSanctuaryGoldPromotion.jpg',
      templates: [{ label: 'Gold Promotion', fields: { introduction: { value: '<p><em>... Because everything under the sun is included<br><\/em><br><strong>Our Lowest Rates of the Year<\/strong><br><br><strong>\u2713Book Direct &amp; Receive*:<\/strong><br>\u2022&nbsp;20% Off Balinese Bed<br>\u2022 10% Off Spa Treatments<br>(excludes beauty salon &amp; product purchases)<br>\u2022 10% Off Late Check-Out Fee<br>\u2022 10% Off Laundry Service<strong><br><\/strong><br><\/p>' }, savings: { value: '' }, subtitle: { value: 'OFFER EXTENDED' }, terms: { value: '<p>Offer valid for a discount off the standard rate for bookings made through December 30th, 2023, for stays through Nov. 30th, 2024.<\/p><p>Guests booking their stay directly at our website are eligible for the following discounts, per room, per stay, subject to availability, for any bookings made through 12\/20\/2024: 20% off Balinese bed, 10% off Spa Services (excludes product purchases and beauty salon services), 10% off late check-out fee, and 10% off laundry service (\u201CDirect Benefits\u201D). Direct Benefits are not applicable for corporate or social groups, conventions or combinable with any other promotional offers, tour packages or special rate programs. Direct Benefits do not hold any cash value, are non-refundable and non-transferable, may not be exchanged for discounts on different services or amenities or re-sold. Direct Benefits must be redeemed at the time of booking the Balinese bed, spa services, late check-out or laundry service, and are only available to guests paying for such services with a major credit card. No deductions will be made at check-out if discount is not redeemed at the time of booking. Blackout dates may apply. This is a limited time offer and may be changed or withdrawn at any time without prior notice. Not responsible for errors or omissions.<\/p><p><br><\/p><p><\/p><p>Book Direct Benefits Terms: Guests booking their stay directly at our website are eligible for the following discounts, per room, per stay, subject to availability, for any bookings made through 12\/20\/2024: 20% off Balinese bed, 10% off Spa Services (excludes product purchases and beauty salon services), 10% off late check-out fee, and 10% off laundry service (\u201CDirect Benefits\u201D). Direct Benefits are not applicable for corporate or social groups, conventions or combinable with any other promotional offers, tour packages or special rate programs. Direct Benefits do not hold any cash value, are non-refundable and non-transferable, may not be exchanged for discounts on different services or amenities or re-sold. Direct Benefits must be redeemed at the time of booking the Balinese bed, spa services, late check-out or laundry service, and are only available to guests paying for such services with a major credit card. No deductions will be made at check-out if discount is not redeemed at the time of booking. Blackout dates may apply. This is a limited time offer and may be changed or withdrawn at any time without prior notice. Not responsible for errors or omissions.<\/p><p><br><\/p>' }, title: { value: 'SEASONAL SAVINGS' } } }],
    })
  },
}
</script>

<template>
  <div class="bg-sanctuary-gold gold-promo text-abs-white py-8">
    <div class="flex justify-center">
      <div class="py-8 md:p-12 container text-center flex flex-col items-center">
        <h6 v-if="fields.subtitle.enabled" class="mb-2 text-white" v-html="fields.subtitle.value" />
        <h3 v-if="fields.title.value" class="uppercase" v-html="fields.title.value" />
        <VoixWysiwyg v-if="fields.introduction.value" class="pt-2 prose-p:pb-4" :field="fields.introduction" />
        <div
          v-if="fields.savings.value"
          class="flex flex-row savings uppercase items-center mb-8"
        >
          <span class="big font-serif">Save</span>
          <div class="flex flex-col mx-4 font-bold">
            <div>Up</div>
            <div>To</div>
          </div>
          <div class="big flex flex-row items-start font-serif -mt-6">
            <span v-if="fields.isDollars.value" class="small mt-6">$</span>
            <span>{{ fields.savings.value }}</span>
            <span v-if="!fields.isDollars.value" class="small mt-6">%</span>
          </div>
        </div>
        <div>
          <PlayaBooking>
            <button class="btn bg-abs-white text-sanctuary-gold mb-2">
              Book Now
            </button>
          </PlayaBooking>
          <terms :terms="fields.terms.value">
            <button class="text-white">
              Terms & Conditions
            </button>
          </terms>
        </div>
      </div>
    </div>
  </div>
</template>
